<template>
  <div>

  </div>
</template>

<script>
export default {
  components: {
  },
  mounted() {
  },
  data: () => ({
    columnDefs: [
      { name: "Make", value: "make", agg: ' %', pivot: true },
      { name: "Model", value: "model", agg: 'sum', pivot: false },
      { name: "Model", value: "model", agg: 'avg', pivot: false },
      { name: "Price", value: "price", agg: '', pivot: false }
    ],
    rowData: [
      { make: "Toyota", model: "Celica", price: 35000 },
      { make: "Ford", model: "Mondeo", price: 32000 },
      { make: "Porsche", model: "Boxster", price: 72000 }
    ]
  })
}
</script>